import {ListItem, styled} from '@mui/material';

export const StyledListItem = styled(ListItem)`
	padding: 8px 0px;
`;
